import AbstractMapper from '@core/utils/mappers/AbstractMapper';
import ISpecialOddDto from '@core/mappers/specials/dtos/ISpecialOddDto';
import { ISpecialOdd } from '@core/models/specials/SpecialOdd';
import { OddStatus } from '@core/models/offer/enums';

export default class SpecialOddMapper extends AbstractMapper<ISpecialOddDto, ISpecialOdd> {

    createTargetObject(dto: ISpecialOddDto, { oddName }: { oddName: string }) {
        return {
            status: dto.status as OddStatus,
            value: dto.value,
            id: dto.oddTypeValueId,
            eventId: dto.oddTypeId,
            name: oddName,

            get isLocked() {
                return this.status !== OddStatus.active || this.value === null;
            },

            get isShownOnOffer() {
                return this.status === OddStatus.active || this.status === OddStatus.block;
            }
        };
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/mappers/specials/SpecialOddMapper.ts